import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { Form } from "react-bootstrap";
import OperatorViewModel from "viewModels/notice/components/operator/operatorViewModel";
import { RadioArray } from "controls/radioArray";

const RepresentativeTypeSelect: FunctionComponent<{
  vm: OperatorViewModel;
}> = observer(({ vm }) => {
  const tg = (code: string) => vm.translateGeneral(`representative.${code}`);

  return (
    <>
      <Form.Group className="mb-3">
        <RadioArray
          custom
          label={tg("applicant")}
          target={vm}
          property="isRepresentedAsProxy"
          isNumeric={false}
          option={false}
          id={"appliciant"}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <RadioArray
          custom
          label={tg("operator")}
          target={vm}
          property="isRepresentedAsProxy"
          isNumeric={false}
          option={true}
          id={"operator"}
        />
      </Form.Group>
    </>
  );
});

export default RepresentativeTypeSelect;
